export const styles = () => ({
  modal: { height: '450px', width: '660px', alignSelf: 'center' }
});
